// Produto pode ter várias categorias (categorias: string[]) — produto antigo
// só tem uma (categoria: string, formato de antes de existir seleção
// múltipla). Normaliza os dois formatos num array só, usado em toda filtragem
// e contagem por categoria (Produtos, Site, loja pública).
export const categoriasDoProduto = (p) => p?.categorias?.length ? p.categorias : (p?.categoria ? [p.categoria] : []);

// O emoji e apenas apresentacao: o nome salvo continua sem prefixo.
const EMOJIS_CATEGORIA = [
  [/mascot|bonec|pelucia/, "\u{1F9F8}"],
  [/anime|manga|otaku/, "\u{1F38C}"],
  [/deck|baralho|card|carta/, "\u{1F0CF}"],
  [/pokemon|pikachu/, "\u26A1"],
  [/magic|magia|mago/, "\u{1FA84}"],
  [/anti.?estress|relax|fidget/, "\u{1F9D8}"],
  [/decor|enfeite|ornamento/, "\u{1F3E0}"],
  [/espada|katana/, "\u2694\uFE0F"],
  [/arma|escudo/, "\u{1F6E1}\uFE0F"],
  [/chaveir|chave/, "\u{1F511}"],
  [/vaso|planta|flor/, "\u{1F33F}"],
  [/animal|pet/, "\u{1F43E}"],
  [/jogo|game/, "\u{1F3AE}"],
  [/suporte|organizador/, "\u{1F9F0}"],
];

export const emojiDaCategoria = (nome = "") => {
  const normalizado = String(nome).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  return EMOJIS_CATEGORIA.find(([padrao]) => padrao.test(normalizado))?.[1] || "\u{1F3F7}\uFE0F";
};

// Associa apenas quando o nome do produto contem o nome da categoria ou uma
// palavra caracteristica. Nomes sem pista suficiente ficam sem categoria.
const NOMES_ANIME = [
  // Titulos e franquias
  "anime", "manga", "naruto", "one piece", "dragon ball", "demon slayer",
  "kimetsu", "jujutsu kaisen", "bleach", "attack on titan", "shingeki no kyojin",
  "my hero academia", "boku no hero", "chainsaw man", "hunter x hunter",
  "sailor moon", "evangelion", "death note", "spy x family", "frieren",
  "fullmetal alchemist", "dandadan", "one punch man", "solo leveling",
  "tokyo ghoul", "haikyuu", "blue lock", "saint seiya", "cavaleiros do zodiaco",
  // Personagens com nomes bem distintivos
  "luffy", "zoro", "sanji", "chopper", "goku", "vegeta", "gohan", "piccolo",
  "broly", "kakashi", "gaara", "madara", "itachi", "sasuke", "gojo", "sukuna",
  "itadori", "tanjiro", "nezuko", "zenitsu", "inosuke", "rengoku", "saitama",
  "genos", "todoroki", "bakugo", "deku", "denji", "makima",
];

const PISTAS_CATEGORIA = {
  chaveiro: [/chaveir/, /key.?chain/],
  espadas: [/espada/, /katana/, /sabre/, /adaga/, /dagger/],
  armas: [/\barma(s)?\b/, /pistola/, /revolver/, /rifle/, /escudo/, /machado/, /axe\b/],
  decoracao: [/decor/, /enfeite/, /ornamento/, /vaso/, /estatua/, /escultura/, /busto/, /luminaria/, /abajur/],
  antiestress: [/anti.?estress/, /fidget/, /spinner/, /relax/, /clicker/, /flexi/, /articulad/],
  pokemon: [/pokemon/, /pikachu/, /bulbasaur/, /charmander/, /squirtle/, /eevee/, /pokebola/, /pokeball/, /charizard/, /gengar/, /snorlax/, /psyduck/, /lucario/, /jigglypuff/, /umbreon/, /sylveon/, /mewtwo/, /\bmew\b/],
  magic: [/\bmagic\b/, /\bmtg\b/, /planeswalker/, /black.?lotus/, /\bmana\b/],
  deckbox: [/deck.?box/, /dock.?box/, /caixa.?de.?baralho/, /porta.?cartas/, /deck.?holder/, /card.?holder/],
  dockbox: [/deck.?box/, /dock.?box/, /caixa.?de.?baralho/, /porta.?cartas/, /deck.?holder/, /card.?holder/],
  mascotes: [/mascot/, /boneco/, /pelucia/, /funko/],
};

const normalizarCategoria = (valor) => String(valor || "")
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
  .replace(/[^a-z0-9]+/g, " ").trim();

export const sugerirCategoriasProduto = (nomeProduto, categorias = []) => {
  const nome = normalizarCategoria(nomeProduto);
  if (!nome) return [];
  const compactado = nome.replace(/ /g, "");
  return categorias
    .map(c => typeof c === "string" ? c : c?.nome)
    .filter(Boolean)
    .filter(categoria => {
      const categoriaNormalizada = normalizarCategoria(categoria);
      const chave = categoriaNormalizada.replace(/ /g, "");
      if (!chave) return false;
      if (nome.includes(categoriaNormalizada) || compactado.includes(chave)) return true;
      if ((chave === "anime" || chave === "animes") &&
          NOMES_ANIME.some(termo => (" " + nome + " ").includes(" " + termo + " "))) return true;
      return (PISTAS_CATEGORIA[chave] || []).some(pista => pista.test(nome));
    });
};

// Mantem categorias existentes e acrescenta as pistas novas, exceto quando
// a pessoa ja definiu as categorias manualmente.
export const categoriasAutomaticasDoProduto = (produto, categorias = []) => {
  const atuais = categoriasDoProduto(produto);
  if (produto?.categoria_manual) return atuais;
  return [...new Set([...atuais, ...sugerirCategoriasProduto(produto?.nome, categorias)])];
};
